import { jsxs as A, Fragment as v, jsx as s } from "react/jsx-runtime";
import { useState as L } from "react";
import { Form as ee } from "react-final-form";
import { useTranslation as oe } from "react-i18next";
import te from "date-fns/differenceInCalendarDays";
import C from "date-fns/format";
import P from "lodash/find";
import m from "lodash/get";
import b from "lodash/has";
import U from "lodash/isEmpty";
import re from "lodash/size";
import se from "@mui/material/Box";
import me from "@mui/material/Divider";
import R from "@mui/material/Grid";
import ie from "@mui/material/Snackbar";
import { makeStyles as ne } from "tss-react/mui";
import ae from "@lumirental/lumi-web-shared/lib/constants/app/SAUDI_MOBILE_CODE";
import ce from "@lumirental/lumi-web-shared/lib/constants/app/SUB_SCREENS_NAME";
import { DEFAULT_BRANCH_DATES as x } from "@lumirental/lumi-web-shared/lib/constants/date/DEFAULT_BRANCH_DATES";
import fe from "@lumirental/lumi-web-shared/lib/constants/form/DRIVER_INFO_FIELD_LIMIT";
import c from "@lumirental/lumi-web-shared/lib/constants/form/FORM_VALIDATION_KEYS";
import le from "@lumirental/lumi-web-shared/lib/utils/getCountryCodePrefix";
import pe from "@lumirental/lumi-web-shared/lib/utils/gtm/umrahReservationSuccess";
import ue from "@lumirental/lumi-web-shared/lib/utils/isValidMinLength";
import { submitToGoogleSheet as de } from "@lumirental/lumi-web-shared/lib/utils/submitToGoogleSheet";
import { manageSmoothScrolling as _e } from "../../../../../utils/index.js";
import Ee from "../../../../common/Button/Button.js";
import be from "../../../../common/Spinner/BackdropSpinner/BackdropSpinner.js";
import { useBusRentalContext as Re } from "../../BusRental.context.js";
import { FIELD_NAME as i, GOOGLE_SHEETS as k } from "../../constant/index.js";
import Ne from "./ReservationRequestForm.style.js";
import Se from "../PersonalInfoForm/PersonalInfoForm.js";
import he from "../RouteInfoForm/RouteInfoForm.js";
import Ie from "../TripDateForm/TripDateForm.js";
import Me from "../AdditionalInfoForm/AdditionalInfoForm.js";
const Oe = ne()(Ne), De = /^(?:\+\d{1,3}\s?)?\d{6,14}$/, Be = /^0/, Te = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, ye = (r) => De.test(r), Ae = (r) => Be.test(r), Le = (r) => Te.test(r), ge = (r, t) => P(
  r,
  (n) => n === i.CUSTOM_ROUTE
) ? r.map((n) => n === i.CUSTOM_ROUTE ? t : n).join(", ").replaceAll("_", " ") : r.join(", ").replaceAll("_", " "), Fe = (r) => {
  const { name: t, email: p, mobileNumber: n, route: O, pickupDate: N, dropoffDate: D } = r;
  return !!t && !!p && !!n && !!O && !!N && !!D;
}, Ce = () => {
  const { classes: r } = Oe(), { t } = oe(), [p, n] = L(!1), [O, N] = L(!1), [D, V] = L(
    t("request_submitted_success")
  ), {
    appEnv: q,
    pickupDate: S,
    setPickUpDate: w,
    dropoffDate: h,
    setDropOffDate: H,
    selectedCountry: Z,
    showSubmitSuccess: $,
    setSelectedRoute: j
  } = Re(), G = q === "production", z = (e) => {
    const o = {}, l = b(e, i.FULL_NAME), u = b(e, i.EMAIL), d = b(e, i.MOBILE_NUMBR), I = b(e, i.ROUTE), F = U(m(e, i.ROUTE, [])), M = !!P(
      m(e, i.ROUTE),
      (E) => E === i.CUSTOM_ROUTE
    ), B = b(e, i.PLAN_INFO), T = m(e, i.FULL_NAME, "").trim();
    l ? ue(T, fe.MIN) && (o.fullName = t(c.SHORT_NAME)) : o.fullName = t("enter_your_full_name"), !u || U(e.email) ? o.email = t(c.ENTER_EMAIL_ADDRESS) : Le(e.email) || (o.email = t(c.INVALID_EMAIL_ADDRESS)), d || (o.mobileNumber = t(c.ENTER_MOBILE_NUMBER));
    const f = ye(e.mobileNumber);
    !f && d && (o.mobileNumber = t(c.INVALID_MOBILE_NUMBER));
    const _ = re(e.mobileNumber);
    return f && _ > 0 && _ < 6 && (o.mobileNumber = t(c.SHORT_MOBILE_NUMBER)), f && _ > 12 && (o.mobileNumber = t(c.LONG_MOBILE_NUMBER)), Ae(e.mobileNumber) && (o.mobileNumber = t(c.MOBILE_WITH_ZERO)), (!I || F) && (o.route = [t("please_select_route")]), M && !B && (o.planInformation = t("please_enter_your_plan_details")), Object.keys(o).length ? o : void 0;
  }, W = async (e, o) => {
    const l = m(e, "fullName", ""), u = m(e, "email", ""), d = m(e, "mobileNumber", ""), I = m(e, "message", ""), M = m(e, "preferredBusType", "").toLowerCase().replace("_", " "), B = m(e, "route", []), T = m(e, "planInformation", ""), f = ge(B, T), _ = m(Z, "code", ae), E = `${le(`${_}`, !1)} ${d}`, Y = C(S, "dd/MM/yyyy"), J = C(h, "dd/MM/yyyy"), Q = te(h, S) || 1;
    if (Fe({
      name: l,
      email: u,
      mobileNumber: d,
      route: f,
      pickupDate: S,
      dropoffDate: h
    })) {
      const a = new FormData();
      a.append("Name", l), a.append("Pickup Date", Y), a.append("Dropoff Date", J), a.append("Route", f), a.append("Bus Type ", M), a.append("Email", u), a.append("Phone", E), a.append("Message", I), n(!0);
      const X = G ? k.RESERVATION_FORM_PROD : k.RESERVATION_FORM_LOCAL, { isValid: y } = await de(X, a);
      y && (pe(
        ce.UMRAH,
        S,
        h,
        f,
        M,
        u,
        E,
        I,
        Q
      ), setTimeout(() => {
        o.reset({}), g(y), w(x.PICKUP), H(x.DROPOFF), $(), j(""), _e("#reservationForm");
      }, 300)), g(y);
    }
  }, g = (e) => {
    const o = t(e ? "request_submitted_success" : "submit_form_error");
    V(o), N(!0);
  };
  return /* @__PURE__ */ A(v, { children: [
    /* @__PURE__ */ s(
      ee,
      {
        validate: z,
        onSubmit: W,
        render: (e) => {
          const { handleSubmit: o } = e;
          return /* @__PURE__ */ s(
            "form",
            {
              onSubmit: (l) => {
                o(l);
              },
              children: /* @__PURE__ */ A("div", { className: r.formWrapper, children: [
                /* @__PURE__ */ A(R, { container: !0, className: r.form, children: [
                  /* @__PURE__ */ s(R, { item: !0, xs: 12, mb: { xs: 3, sm: 6 }, children: /* @__PURE__ */ s(Se, {}) }),
                  /* @__PURE__ */ s(R, { item: !0, xs: 12, mb: { xs: 3, sm: 6 }, id: "routeInfoForm", children: /* @__PURE__ */ s(he, {}) }),
                  /* @__PURE__ */ s(R, { item: !0, xs: 12, mb: { xs: 3, sm: 6 }, children: /* @__PURE__ */ s(Ie, {}) }),
                  /* @__PURE__ */ s(R, { item: !0, xs: 12, mb: { xs: 3, sm: 3 }, children: /* @__PURE__ */ s(Me, {}) })
                ] }),
                /* @__PURE__ */ s(
                  me,
                  {
                    sx: { marginTop: 2, marginBottom: 3 },
                    className: r.divider
                  }
                ),
                /* @__PURE__ */ s(se, { sx: { textAlign: "right" }, children: /* @__PURE__ */ s(
                  Ee,
                  {
                    fullWidth: !0,
                    type: "submit",
                    disabled: p,
                    dataTestid: "reservationRequestSubmitBtn",
                    className: r.submitBtn,
                    children: t("send_request")
                  }
                ) })
              ] })
            }
          );
        }
      }
    ),
    /* @__PURE__ */ s(be, { show: p }),
    /* @__PURE__ */ s(
      ie,
      {
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "center"
        },
        open: O,
        onClose: (e, o) => {
          o !== "clickaway" && (N(!1), n(!1));
        },
        autoHideDuration: 2e3,
        message: D,
        "data-testid": "submitBusReservationRequestMsg"
      }
    )
  ] });
}, Ro = Ce;
export {
  Ro as default
};
